import React from 'react';

import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import Confirmation from 'clientCommunications/components/Reminders/Confirmation.component';

const FREE_MARKETING_TEXTS = 50;

const EssentialList = () => {
  const { t } = useTranslation();

  return (
    <ul>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>
        {S.markX} {t('staffAndBusiness.subAndBilling.pricePlan.notIncluded')}
      </li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>
        {S.markX} {t('staffAndBusiness.subAndBilling.pricePlan.notIncluded')}
      </li>
      <li>{S.markV}</li>
      <li>
        {S.markX} {t('staffAndBusiness.subAndBilling.pricePlan.notIncluded')}
      </li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{S.markV}</li>
      <li>{t('staffAndBusiness.subAndBilling.pricePlan.unlimitedDevicesLogins')}</li>
      <li>{S.markV}</li>
      <li>
        {S.markV} {t('staffAndBusiness.subAndBilling.pricePlan.onePerMonth')}
      </li>
      <li>
        {S.markV} {t('staffAndBusiness.subAndBilling.pricePlan.unlimited')}
      </li>
      <li>
        <Confirmation variant="billing" tag="EssentialList" />
      </li>
      <li>{FREE_MARKETING_TEXTS}</li>
    </ul>
  );
};

export default EssentialList;
